import React, {useState, useContext, useEffect} from 'react'
import ConfigContext from '../contexts/configContext'
import FormInputs from './FormInputs';
import Button from '@mui/material/Button';

export default function PreCallForm({meetingId, pin, onSubmit, onSipHeadersChange, onExtensionChange, onCallerNameChange, onMeetingIdChange, onPINChange}) {
  const config = useContext(ConfigContext)
  const [inputs, setInputs] = useState([])
  const [hasAllRequired, setHasAllRequired] = useState(false)
  const [webhookUrl, setWebhookUrl] = useState(null)
  const [webhookParams, setWebhookParams] = useState({})

  useEffect(() => {
    if (config?.precallform?.hasOwnProperty('inputs')) setInputs(config.precallform.inputs)
    if (config?.precallform?.hasOwnProperty('resultWebhook')) setWebhookUrl(config.precallform.resultWebhook)
  }, [])

  const callWebhook = async () => {
    const response = await fetch(webhookUrl, {
        method: 'POST',
        body: JSON.stringify(webhookParams),
    });
  };

  return (
    <div className='live-call-precallform'>
        <h1>
            {config?.precallform?.headerTxt
                ? config.precallform.headerTxt
                : "Questionaire"
            }
        </h1>
        <p>
            {config?.precallform?.introTxt
                ? config.precallform.introTxt
                : "Please answer the questions below"
            }
        </p>
        <FormInputs
            precall
            formInputs={inputs}
            meetingId={meetingId}
            pin={pin}
            onHasAllRequired={hasAll => setHasAllRequired(hasAll)}
            onCallerNameChange={onCallerNameChange}
            onExtensionChange={onExtensionChange}
            onSipHeadersChange={onSipHeadersChange}
            onWebhookParamsChange={params => setWebhookParams(params)}
            onMeetingIdChange={onMeetingIdChange}
            onPINChange={onPINChange}
        />
        <Button 
            disabled={!hasAllRequired}
            sx={{m:1}}
            variant="contained"
            size="large"
            onClick={() => {
                if (webhookUrl && Object.keys(webhookParams).length > 0) callWebhook()
                onSubmit()
            }}
        >
            {config?.precallform?.submitButtonTxt
                ? config.precallform.submitButtonTxt
                : "Submit"
            }
        </Button>
    </div>
  )
}
